import React from 'react';
import moment from 'moment';
import { convertDays } from 'shared-utils';
import { DateSloteCard } from './DateSloteCard';

type Props = {
	allSlots: any; // DayTimeSlot[];
	selectedDaySlot?: any; // DayTimeSlot;
	setSelectedDaySlot: (value: any) => void;
};

export const DateSelection = ({ allSlots, selectedDaySlot, setSelectedDaySlot }: Props) => {
	return (
		<div className={'mb-0'}>
			<p className={`${'greyish_text_dark_theme dark:text-[#C7C9D9] font-[500] text-[15px]'}`}>Select a date</p>
			<div className="p-2 pl-0 overflow-x-auto scrollPracticeTopics" id="date_selection_scroll_div_container">
				<div className="flex gap-4 " id="date_selection_scroll_div">
					{allSlots?.map((availability: any, ind: number) => {
						const isSelected = selectedDaySlot?.date === availability.date;
						return (
							<DateSloteCard
								key={ind}
								day={convertDays(availability.day)}
								date={moment(availability.date).format('DD MMM')}
								slotAvailable={availability.totalSlots}
								isSelected={isSelected}
								startTime={availability.date}
								setSelectedDaySlot={setSelectedDaySlot}
								availability={availability}
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
};
